let routes = [
  {
    path: '/material',
    name: 'materials',
    component: () => import('./components/MaterialsMain.vue')
  },
  {
    path: '/material/:modell',
    name: 'MaterialDetails',
    component: () => import('./components/MaterialsDetail.vue')
  }
]

export default routes
